//主页面
const index = () => import('@/components/home.vue');

//审批配置表
const approvalConfig = () => import('@/pages/todoCenter/approval/approvalConfig.vue');
//审批配置表新增
const approvalConfigAdd = () => import('@/pages/todoCenter/approval/approvalConfigAdd.vue');
//标题配置
const titleConfig = () => import('@/pages/todoCenter/title/list.vue');
//标题配置修改
const titleConfigEdit = () => import('@/pages/todoCenter/title/edit.vue');
//待办已办
// const task = () => import('@/pages/todoCenter/task/list.vue');
//单据配置
const billConfig = () => import('@/pages/todoCenter/bill/list.vue');
//单据配置修改
const billConfigEdit = () => import('@/pages/todoCenter/bill/edit.vue');

const systemRouter = {
  path: '/todoCenter',
  component: index,
  children: [
    {
      path: 'approvalConfig',
      name: 'approvalConfig',
      component: approvalConfig,
      meta: {
        keepAlive: true,
        title: '审批配置',
      },
    },
    {
      path: 'approvalConfigAdd',
      name: 'approvalConfigAdd',
      component: approvalConfigAdd,
      meta: {
        keepAlive: true,
        title: '审批配置新增',
      },
    },
    {
      path: 'approvalConfigEdit',
      name: 'approvalConfigEdit',
      component: approvalConfigAdd,
      meta: {
        keepAlive: true,
        title: '审批配置编辑',
      },
    },
    {
      path: 'titleConfig',
      name: 'titleConfig',
      component: titleConfig,
      meta: {
        keepAlive: true,
        title: '标题配置',
      },
    },
    {
      path: 'titleConfigEdit',
      name: 'titleConfigEdit',
      component: titleConfigEdit,
      meta: {
        keepAlive: true,
        title: '标题配置修改',
      },
    },
    {
      path: 'titleConfigAdd',
      name: 'titleConfigAdd',
      component: titleConfigEdit,
      meta: {
        keepAlive: true,
        title: '标题配置新增',
      },
    },
    {
      path: 'task',
      name: 'task',
      component: () => import('@/pages/todoCenter/task/list.vue'),
      meta: {
        keepAlive: true,
        title: '待办/已办',
      },
    },
    {
      path: 'billConfig',
      name: 'billConfig',
      component: billConfig,
      meta: {
        keepAlive: true,
        title: '单据配置',
      },
    },
    {
      path: 'billConfigAdd',
      name: 'billConfigAdd',
      component: billConfigEdit,
      meta: {
        keepAlive: true,
        title: '单据配置新增',
      },
    },
    {
      path: 'billConfigEdit',
      name: 'billConfigEdit',
      component: billConfigEdit,
      meta: {
        keepAlive: true,
        title: '单据配置修改',
      },
    },
  ],
};

export default systemRouter;
